import { addToCart } from "./add-to-cart";

class addToCartBtn extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      addToCartBtn: this.querySelector(".add-to-cart-btn"),
    };

    this.elements.addToCartBtn.addEventListener("click", async (e) => {
      e.preventDefault();

      const variantId = this.querySelector('[name="id"]')?.value;
      const variantQnt = this.querySelector('[name="quantity"]')?.value || 1;

      await addToCart([{ id: variantId, quantity: variantQnt }]);
    });
  }
}

if (!customElements.get("add-to-cart-btn")) {
  customElements.define("add-to-cart-btn", addToCartBtn);
}
